import styled from "styled-components";
import { borders } from "@sonder/ui/source/styled/theme";

export const SvgIconWrapper = styled.div`
  align-items: center;
  border-radius: 100%;
  border: ${borders.standard};
  box-sizing: border-box;
  display: flex;
  height: 2rem;
  justify-content: center;
  width: 2rem;

  & svg {
    display: block;
    height: 100%;
    transform: scale(0.7);
    width: 100%;
  }
`;
